/**
 * Demo step shown ONLY on /demo-odonto, right after the cover.
 * Quick visual preview of the 6 dental-suite pillars.
 */
import React from "react";
import {
  Database, Activity, Sparkles, ScanLine, FileSignature, Wallet,
  CheckCircle2, Crown,
} from "lucide-react";

const PILLARS = [
  {
    icon: Database,
    badge: "MIGRATION",
    title: "Migrazione intelligente",
    sub: "Importi i pazienti da TeleRicetta o AlfaDocs in 60 secondi.",
    grad: "from-violet-500 to-fuchsia-500",
    chips: ["Auto-mapping", "Dedup", "GDPR"],
  },
  {
    icon: Activity,
    badge: "ODONTOGRAMMA",
    title: "Odontogramma avanzato",
    sub: "Cartella interattiva 32 denti, audit log per ogni modifica.",
    grad: "from-cyan-500 to-blue-600",
    chips: ["FDI · 8 stati", "Touch-friendly", "Timeline"],
  },
  {
    icon: Sparkles,
    badge: "SMART RECORDS",
    title: "Cartella clinica AI",
    sub: "Anamnesi strutturata, alert allergie, recall automatici.",
    grad: "from-emerald-500 to-teal-500",
    chips: ["Claude Sonnet", "Alert", "Recall"],
  },
  {
    icon: ScanLine,
    badge: "PATIENT INTAKE",
    title: "Acquisizione paziente AI",
    sub: "Fotografi CI o tessera sanitaria, l'AI compila la scheda.",
    grad: "from-amber-500 to-orange-500",
    chips: ["OCR Vision", "CF validato", "10 secondi"],
  },
  {
    icon: FileSignature,
    badge: "CONSENSI",
    title: "Firma digitale moduli",
    sub: "Il paziente firma privacy e consensi dal suo smartphone.",
    grad: "from-violet-500 to-blue-500",
    chips: ["Senza app", "QR · WhatsApp", "PDF GDPR"],
  },
  {
    icon: Wallet,
    badge: "BILLING",
    title: "Ricevute SDI-ready",
    sub: "Ricevute progressive PDF, stati pagamento e dashboard economica.",
    grad: "from-sky-500 to-teal-600",
    chips: ["YYYY/NNNN", "PDF", "SDI-ready"],
  },
];

const DentalSuiteStep = () => (
  <div className="space-y-5" data-testid="dental-suite-step">
    <div className="text-center">
      <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-gradient-to-r from-violet-600 to-cyan-600 text-white text-[9px] font-bold uppercase tracking-[0.2em] shadow">
        <Crown className="w-2.5 h-2.5" /> Step 2/11 · Dental Suite
      </span>
      <h2 className="text-2xl sm:text-3xl font-bold mt-3">
        Sei tecnologie premium.<br className="hidden sm:block" /> Solo per studi dentistici.
      </h2>
      <p className="text-slate-400 text-sm mt-2 max-w-xl mx-auto">
        Dall'acquisizione del paziente alla ricevuta firmata digitalmente. Tutto integrato.
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {PILLARS.map((p, i) => (
        <div
          key={i}
          className="rounded-2xl border border-slate-700/50 bg-slate-900/50 backdrop-blur p-5 hover:border-violet-400/50 transition-colors"
          data-testid={`dental-suite-step-pillar-${i}`}
        >
          <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${p.grad} flex items-center justify-center shadow-lg mb-3`}>
            <p.icon className="w-4 h-4 text-white" />
          </div>
          <p className="text-[9px] font-bold uppercase tracking-[0.2em] text-violet-300/80">{p.badge}</p>
          <h3 className="text-base font-bold text-white mt-1">{p.title}</h3>
          <p className="text-xs text-slate-400 leading-relaxed mt-1.5">{p.sub}</p>
          <div className="flex flex-wrap gap-1 mt-3">
            {p.chips.map(c => (
              <span key={c} className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-slate-800 text-slate-300 border border-slate-700">
                {c}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>

    <div className="flex items-center justify-center gap-1.5 text-[11px] text-slate-400">
      <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400" />
      Tutto incluso nel piano <strong className="text-white">PRO</strong>. Zero costi nascosti.
    </div>
  </div>
);

export default DentalSuiteStep;
